import type { RouterContextType } from "@/api/permissions/permissions.api";
import { EditClientCoverage } from "@/components/features/ClientDetails/EditClientCoverage/EditClientCoverage";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/clients/$id/edit-client-coverage")({
  component: EditClientCoverageRoute,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function EditClientCoverageRoute() {
  const { id } = useParams({ from: "/clients/$id/edit-client-coverage" });

  return <EditClientCoverage clientId={id} />;
}
